import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';


const PDFViewer = ({ fileUrl, onClose }) => {
  const toolbarPluginInstance = toolbarPlugin();

const { Toolbar } = toolbarPluginInstance;
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
        downloadPlugin: {
            renderDownloadButton: () => <></>,
            renderDownloadMenuItem: () => <></>,
        },
        printPlugin: {
            renderPrintButton: () => <></>,
            renderPrintMenuItem: () => <></>,
        },
    },
});



  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onContextMenu={(e) => e.preventDefault()}
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-xl">
        <div
          className="modal-content"
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-header">
            <h5 className="modal-title">View File</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div
            className="modal-body"
            style={{ height: "80vh" }}
            onContextMenu={(e) => e.preventDefault()}
          >
            <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
            <Toolbar>
    {(props) => (
        <div style={{ display: 'flex', gap: '8px' }}>
            <props.ZoomOut />
            <props.Zoom />
            <props.ZoomIn />
            <props.GoToPreviousPage />
            <props.CurrentPageInput />
            <props.NumberOfPages />
            <props.GoToNextPage />
        </div>
    )}
</Toolbar>

<Viewer
    fileUrl={fileUrl}
    plugins={[toolbarPluginInstance]}
/>
               
            </Worker>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;